export default __webpack_public_path__ + "images/inmarket-lci-logo.43a0980e010254ea270f15be3d7c5348.png";